import {
  USER_LOGIN,
  USER_LOGOUT,
  USER_IS_LOGGED_IN,
  USER_CHANGE_PASSWORD,
  USER_LOGIN_GUEST,
} from '../../constants';

export const login = (email, password) => ({
  type: 'USER',
  cmd: USER_LOGIN,
  payload: { email, password },
  remote: true,
  status: 'login',
});

export const loginGuest = (email) => ({
  type: 'USER',
  cmd: USER_LOGIN_GUEST,
  payload: { email },
  remote: true,
  status: 'login',
});

export const logout = () => ({
  type: 'USER',
  cmd: USER_LOGOUT,
  remote: true,
});

export const isLoggedIn = () => ({
  type: 'USER',
  cmd: USER_IS_LOGGED_IN,
  remote: true,
});

export const changePassword = (oldPass, newPass) => ({
  type: USER_CHANGE_PASSWORD,
  cmd: USER_CHANGE_PASSWORD,
  payload: { oldPass, newPass },
  remote: true,
  status: 'passwordModal',
});
